import { toast } from 'react-toastify';
import PageNotFound from './Components/PageNotFound';

import AboutUsPage from "./Pages/AboutUsPage";
import Clients from "./Pages/Clients";
import ContactUsPage from "./Pages/ContactUsPage";
import DashboardHomeAboutSection from "./Pages/DashboardPages/DashboardAboutSection";
import DashboardAboutUs from "./Pages/DashboardPages/DashboardAboutUs";
import DashboardBanner from "./Pages/DashboardPages/DashboardBanner";
import DashboardContactUs from "./Pages/DashboardPages/DashboardContactUs";
import DashboardDocument from "./Pages/DashboardPages/DashboardDocument";
import DashboardDocumentView from './Pages/DashboardPages/DashboardDocumentView';
import DashboardFachSheet from "./Pages/DashboardPages/DashboardFachSheet";
import DashboardNews from "./Pages/DashboardPages/DashboardNews";
import DashboardJobListing from './Pages/DashboardPages/DashboardJobListing';
import DashboardKeyFeatures from "./Pages/DashboardPages/DashboardKeyFeatures";
import DashboardLocations from "./Pages/DashboardPages/DashboardLocations";
import DashboardService from "./Pages/DashboardPages/DashboardService";
import DashboardTestimonial from "./Pages/DashboardPages/DashboardTestimonial";
import DashboardClient from "./Pages/DashboardPages/DashboardClient";
import DashboardMenuItems from "./Pages/DashboardPages/DashboardMenuItems";
import DashboardNewsLetter from './Pages/DashboardPages/DashboardNewsLetter';
import DashboardPage from "./Pages/DashboardPages/DashboardPage";
import DashboardPartnerInquiries from "./Pages/DashboardPages/DashboardPartnerInquiries";
import DashboardSettings from "./Pages/DashboardPages/DashboardSettings";
import DashboardWrapper from "./Pages/DashboardPages/DashboardWrapper";
import LoginPage from "./Pages/DashboardPages/LoginPage";
import HomePage from "./Pages/HomePage";
import InquiryForm from "./Pages/InquiryForm";
import Jobs from "./Pages/Jobs";
import Location from "./Pages/Location";
import PageDynamic from "./Pages/PageDynamic";
import PartnerShipInquiry from "./Pages/PartnerShipInquiry";
import ServicesPages from "./Pages/ServicesPages";
import TrailbossBurner from "./Pages/TrailbossBurner";
import TrailBossNews from "./Pages/TrailBossNews";
import DashboardHome from "./Pages/DashboardPages/DashboardHome";
import UnauthorizedAccess from './Components/Authentication/UnauthorizedAccess';

const showToast = (type, message) => {
    if (type == 'success') {
        toast.success(message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    } else {
        toast.error(message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    }
}
const AppRoutes = [
    {
        path: '/',
        index: true,
        element: <HomePage />
    },
    {
        path: '/login',
        element: <LoginPage />
    },
    {
        path: '/7103122Kaydie090896',
        element: <DashboardHome showToast={showToast} />
    },
    {
        path: '/dashboard-page',
        element: <DashboardPage showToast={showToast} />
    },
    {
        path: '/dashboard-banner',
        element: <DashboardBanner showToast={showToast} />
    },
    {
        path: '/dashboard-news',
        element: <DashboardNews showToast={showToast} />
    },
    {
        path: '/dashboard-menu-items',
        element: <DashboardMenuItems showToast={showToast} />
    },
    {
        path: '/dashboard-settings',
        element: <DashboardSettings showToast={showToast} />
    },
    {
        path: '/dashboard-contact-us',
        element: <DashboardContactUs showToast={showToast} />
    },
    {
        path: '/dashboard-partener-inquires',
        element: <DashboardPartnerInquiries showToast={showToast} />
    },
    {
        path: '/dashboard-locations',
        element: <DashboardLocations showToast={showToast} />
    },
    {
        path: '/dashboard-service',
        element: <DashboardService showToast={showToast} />
    },
    {
        path: '/dashboard-testimonial',
        element: <DashboardTestimonial showToast={showToast} />
    },
    {
        path: '/dashboard-client',
        element: <DashboardClient showToast={showToast} />
    },
    {
        path: '/dashboard-keyfeatures',
        element: <DashboardKeyFeatures showToast={showToast} />
    },
    {
        path: '/dashboard-newsletter',
        element: <DashboardNewsLetter showToast={showToast} />
    },
    {
        path: '/dashboard-joblisting',
        element: <DashboardJobListing showToast={showToast} />
    },
    {
        path: '/about',
        element: <AboutUsPage />
    },
    {
        path: '/news',
        element: <TrailBossNews />
    },
    {
        path: '/trailboss-burner',
        element: <TrailbossBurner />
    },
    {
        path: '/services',
        element: <ServicesPages />
    },
    {
        path: '/location',
        element: <Location />
    },
    {
        path: '/clients',
        element: <Clients />
    },
    {
        path: '/contact',
        element: <ContactUsPage showToast={showToast} />
    },
    {
        path: '/partnership-inquiry',
        element: <PartnerShipInquiry />
    },
    {
        path: '/inquiry-form',
        element: <InquiryForm showToast={showToast} />
    },
    {
        path: '/jobs',
        element: <Jobs />
    },
    {
        path: '/page',
        element: <PageDynamic />
    },
    {
        path: '/dashboard-factsheet',
        element: <DashboardFachSheet showToast={showToast} />
    },
    {
        path: '/dashboard-homeaboutSection',
        element: <DashboardHomeAboutSection showToast={showToast} />
    },
    {
        path: '/dashboard-about-us',
        element: <DashboardAboutUs showToast={showToast} />
    },
    {
        path: '/dashboard-wrapper',
        element: <DashboardWrapper showToast={showToast} />
    },
    {
        path: '/dashboard-document',
        element: <DashboardDocument showToast={showToast} />
    },
    {
        path: '/dashboard-document-view',
        element: <DashboardDocumentView showToast={showToast} />
    },
    {
        path: '/unauthorized',
        element: <UnauthorizedAccess />
    },
    {
        path: '*',
        element: <PageNotFound />
    }
];

export default AppRoutes;
